import { createContext } from "react";
import useLocalStorageState from "../hooks/useLocalStorageState";

export const SourceProviderContext = createContext();

const SourceProvider = ({ children }) => {
  const [sourceData, setSourceData] = useLocalStorageState("sourceData", "");
  return (
    <SourceProviderContext.Provider
      value={{
        sourceData,
        setSourceData,
      }}
    >
      {children}
    </SourceProviderContext.Provider>
  );
};

export default SourceProvider;
